import {
    Box,
    Container,
    Grid,
    Typography
} from "@mui/material";

const COLORS = {
    light: "#b8e28a",
    dark: "#4e6b4d",
};

const MisionVisionValores = () => {
    return (
        <Box
            sx={{
                backgroundColor: "#f7f7f7",
                pb: {
                    xs: 8,
                    md: 12,
                },
            }}
        >
            {/* Header decorativo */}
            <Box
                component="img"
                src="/img/mvv.png"
                alt="Misión Visión Valores"
                sx={{
                    width: "100%",
                    display: "block",
                    mb: {
                        xs: 4,
                        md: 8,
                    },
                }}
            />

            <Container maxWidth="xl">
                <Grid
                    container
                    spacing={{
                        xs: 6,
                        md: 4,
                        lg: 8,
                    }}
                >
                    {/* VISIÓN */}
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Box
                            sx={{
                                textAlign: {
                                    xs: "center",
                                    md: "left",
                                },
                                height: "100%",
                            }}
                        >
                            <Typography
                                sx={{
                                    color: COLORS.dark,
                                    fontSize: {
                                        xs: "2rem",
                                        md: "3rem",
                                    },
                                    fontWeight: 300,
                                    mb: 3,
                                }}
                            >
                                VISION
                            </Typography>

                            <Typography
                                sx={{
                                    color: COLORS.dark,
                                    fontSize: "1.15rem",
                                    lineHeight: 2,
                                }}
                            >
                                Ser la institución financiera{" "}
                                <Box component="span" sx={{ fontWeight: 700, fontStyle: "italic" }}>
                                    LÍDER EN MÉXICO
                                </Box>{" "}
                                reconocida por transformar la cultura del dinero a través de la{" "}
                                <Box component="span" sx={{ fontWeight: 700, fontStyle: "italic" }}>
                                    INNOVACIÓN, LEGALIDAD Y EL SENTIDO HUMANO;
                                </Box>{" "}
                                consolidando una red nacional de prosperidad donde la{" "}
                                <Box component="span" sx={{ fontWeight: 700, fontStyle: "italic" }}>
                                    DISCIPLINA
                                </Box>{" "}
                                y la{" "}
                                <Box component="span" sx={{ fontWeight: 700, fontStyle: "italic" }}>
                                    TRANSPARENCIA
                                </Box>{" "}
                                sean los{" "}
                                <Box component="span" sx={{ fontWeight: 700, fontStyle: "italic" }}>
                                    CIMIENTOS DEL ÉXITO MUTUO.
                                </Box>
                            </Typography>
                        </Box>
                    </Grid>

                    {/* MISIÓN */}
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Box
                            sx={{
                                textAlign: "center",
                                px: {
                                    md: 4,
                                },
                                borderLeft: {
                                    md: `3px solid ${COLORS.dark}`,
                                },
                                borderRight: {
                                    md: `3px solid ${COLORS.dark}`,
                                },
                                height: "100%",
                            }}
                        >
                            <Typography
                                sx={{
                                    color: COLORS.dark,
                                    fontSize: {
                                        xs: "2rem",
                                        md: "3rem",
                                    },
                                    fontWeight: 300,
                                    mb: 3,
                                }}
                            >
                                MISION
                            </Typography>

                            <Typography
                                sx={{
                                    color: COLORS.dark,
                                    fontSize: "1.15rem",
                                    lineHeight: 2,
                                }}
                            >
                                Apoyar y guiar al mayor número de personas con necesidades económicas y financieras mediante{" "}
                                <Box component="span" sx={{ fontWeight: 700, fontStyle: "italic" }}>
                                    SOLUCIONES ÁGILES DE CRÉDITO, AHORRO E INVERSIÓN,
                                </Box>{" "}
                                respaldadas por una educación integral que sustituya el estrés por orden y el miedo por abundancia,{" "}
                                <Box component="span" sx={{ fontWeight: 700, fontStyle: "italic" }}>
                                    IMPACTANDO POSITIVAMENTE EN EL BIENESTAR DE LA SOCIEDAD.
                                </Box>
                            </Typography>
                        </Box>
                    </Grid>

                    {/* VALORES */}
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Box
                            sx={{
                                textAlign: {
                                    xs: "center",
                                    md: "right",
                                },
                                height: "100%",
                            }}
                        >
                            <Typography
                                sx={{
                                    color: COLORS.dark,
                                    fontSize: {
                                        xs: "2rem",
                                        md: "3rem",
                                    },
                                    fontWeight: 300,
                                    mb: 3,
                                }}
                            >
                                VALORES
                            </Typography>

                            <Typography
                                sx={{
                                    color: COLORS.dark,
                                    fontSize: "1.15rem",
                                    lineHeight: 2,
                                }}
                            >
                                <strong><i>CONFIANZA E INTEGRIDAD</i></strong>
                                <br />
                                Actuamos bajo el marco legal y la transparencia total
                                <br />

                                <strong><i>RESPETO</i></strong>
                                <br />
                                Valoramos el tiempo y la realidad de cada persona
                                <br />

                                <strong><i>HONESTIDAD</i></strong>
                                <br />
                                Hablamos con la verdad y claridad en cada etapa del proceso
                                <br />

                                <strong><i>TRABAJO EN EQUIPO</i></strong>
                                <br />
                                Trabajamos en equipo para multiplicar resultados
                                <br />

                                <strong><i>ABUNDANCIA</i></strong>
                                <br />
                                Creemos en el crecimiento compartido; si tú creces, nosotros también.
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default MisionVisionValores;